import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { formatCurrency } from '../../utils/currency';
import './Rentals.css';

function Rentals() {
  const [rentals, setRentals] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    // Mock data
    const mockRentals = [
      {
        id: 1,
        rentalNo: 'RENT-2023-001',
        customer: 'John Doe',
        equipment: 'Power Generator 5KVA',
        rentDate: '2023-10-01',
        returnDate: '2023-10-08',
        status: 'active',
        deposit: 5000,
        total: 15000
      },
      {
        id: 2,
        rentalNo: 'RENT-2023-002',
        customer: 'ABC Construction',
        equipment: 'Concrete Mixer',
        rentDate: '2023-10-05',
        returnDate: '2023-10-12',
        status: 'completed',
        deposit: 8000,
        total: 24000
      },
      {
        id: 3,
        rentalNo: 'RENT-2023-003',
        customer: 'Jane Smith',
        equipment: 'Scaffolding Set',
        rentDate: '2023-10-10',
        returnDate: '2023-10-15',
        status: 'overdue',
        deposit: 3000,
        total: 9000
      }
    ];
    setRentals(mockRentals);
  }, []);

  const filteredRentals = filter === 'all' 
    ? rentals 
    : rentals.filter(rental => rental.status === filter);

  return (
    <Layout>
      <div className="rentals-container">
        <div className="page-header">
          <h1>Rentals</h1>
          <button className="btn-primary">+ New Rental</button>
        </div>

        <div className="filter-tabs">
          {['all', 'active', 'completed', 'overdue'].map(status => (
            <button
              key={status}
              className={`filter-tab ${filter === status ? 'active' : ''}`}
              onClick={() => setFilter(status)}
            >
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </button>
          ))}
        </div>

        <div className="rentals-table-container">
          <table className="rentals-table">
            <thead>
              <tr>
                <th>Rental No</th>
                <th>Customer</th>
                <th>Equipment</th>
                <th>Rent Date</th>
                <th>Return Date</th>
                <th>Deposit</th>
                <th>Total</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRentals.map(rental => (
                <tr key={rental.id}>
                  <td>{rental.rentalNo}</td>
                  <td>{rental.customer}</td>
                  <td>{rental.equipment}</td>
                  <td>{rental.rentDate}</td>
                  <td>{rental.returnDate}</td>
                  <td>{formatCurrency(rental.deposit)}</td>
                  <td>{formatCurrency(rental.total)}</td>
                  <td>
                    <span className={`status-badge ${rental.status}`}>
                      {rental.status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-view">View</button>
                      {rental.status === 'active' && (
                        <button className="btn-return">Return</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

export default Rentals;